import { BASE_FLIRT_URL, PROMOBOX_MANAGER_PATH } from './constants';

export const getProductPromoboxManagemodelCMSUrl = (promoboxId: string): string => {
  return `${BASE_FLIRT_URL}${PROMOBOX_MANAGER_PATH}?promoboxid=${promoboxId}`;
};
